// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1AP6p","errorLogs":"styles_errorLogs__2RXUK"};